import { FormGroup } from "../../../components/FormGroup";
import { FormLabel } from "../../../components/FormLabel";
import type { OfferTarget } from "@KassaroAB/shared/types/offer";
import type {
  ProductGroupId,
  ProductId,
} from "@KassaroAB/shared/types/ids";
import { CheckboxLabel, CheckboxList } from "./offerFormStyles";

interface OfferTargetFieldsProps {
  value: OfferTarget;
  onChange: (value: OfferTarget) => void;
  products: { id: ProductId; name: string }[];
  groups: { id: ProductGroupId; name: string }[];
  productsLabel: string;
  groupsLabel: string;
}

export const OfferTargetFields = ({
  value,
  onChange,
  products,
  groups,
  productsLabel,
  groupsLabel,
}: OfferTargetFieldsProps) => (
  <>
    <FormGroup>
      <FormLabel>{productsLabel}</FormLabel>
      <CheckboxList>
        {products.map((product) => (
          <CheckboxLabel key={product.id}>
            <input
              type="checkbox"
              checked={value.productIds.includes(product.id)}
              onChange={(e) => {
                const productIds = e.target.checked
                  ? [...value.productIds, product.id]
                  : value.productIds.filter((id) => id !== product.id);
                onChange({ ...value, productIds });
              }}
            />
            {product.name}
          </CheckboxLabel>
        ))}
      </CheckboxList>
    </FormGroup>
    <FormGroup>
      <FormLabel>{groupsLabel}</FormLabel>
      <CheckboxList>
        {groups.map((group) => (
          <CheckboxLabel key={group.id}>
            <input
              type="checkbox"
              checked={value.groupIds.includes(group.id)}
              onChange={(e) => {
                const groupIds = e.target.checked
                  ? [...value.groupIds, group.id]
                  : value.groupIds.filter((id) => id !== group.id);
                onChange({ ...value, groupIds });
              }}
            />
            {group.name}
          </CheckboxLabel>
        ))}
      </CheckboxList>
    </FormGroup>
  </>
);
